<template>
  <section
    v-loading="dashboardLoading"
    class="cso-panel"
    :class="scope.clsPrefix"
  >
    <div class="panel-head">
      <span class="panel-title">供应链核心 KPI</span>
    </div>
    <div class="panel-body">
      <div v-if="items.length" class="kpi-grid">
        <div class="indicator-item" v-for="item in items" :key="item.label">
          <div class="indicator-main">
            <span class="indicator-name">{{ item.label }}</span>
            <span class="indicator-trend" :class="item.trendClass">
              <span class="trend-value">{{ item.trendText }}</span>
              <span class="trend-icon">{{ item.trendIcon }}</span>
            </span>
          </div>
          <div class="indicator-value">
            <span class="value-num">{{ item.value }}</span>
            <span class="value-unit" v-if="item.unit">{{ item.unit }}</span>
          </div>
        </div>
      </div>
      <div v-else class="panel-empty">暂无数据</div>
    </div>
  </section>
</template>

<script>
import { REGION, groupByRegion, parseIndicator } from '../utils/externalMetrics'

export default {
  name: 'CsoCoreKpi',
  props: {
    dashboardData: {
      type: Object,
      default: () => ({})
    },
    dashboardLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-cso-core-kpi'
      }
    }
  },
  computed: {
    items() {
      const data = this.dashboardData || {}
      const ext = data.externalMetrics
      if (!ext || !Array.isArray(ext.data)) return []
      const group = groupByRegion(ext.data)[REGION.CORE_KPI]
      if (!group || !group.length) return []
      return group.map((item) => {
        const p = parseIndicator(item)
        return {
          label: p.name,
          value: p.value,
          unit: p.unit,
          // 环比文案里的 "pp" 统一替换为 "%"（如 -5.6pp → -5.6%）
          trendText: String(p.trendValue).replace(/(\d)pp/, '$1%'),
          trendIcon: p.trendIcon,
          trendClass: p.trendClass
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: 'rvc-cosmoplat-workspace-cso-core-kpi';

.#{$class-prefix} {
  min-height: 0;
  display: flex;
  flex-direction: column;

  .panel-head {
    background: transparent;
    color: var(--text, #1f2937);
    padding: 12px 18px 6px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .panel-title {
    font-size: 14px;
    font-weight: 600;
    color: rgb(30, 34, 38);
    line-height: 20px;
  }
  .panel-body {
    padding: 8px 18px 16px;
    flex: 1;
    display: flex;
    min-width: 0;
    min-height: 180px;
  }
  .panel-empty {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #94a3b8;
  }
  .kpi-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: repeat(2, minmax(0, 1fr));
    gap: 10px;
    width: 100%;
    flex: 1;
    min-width: 0;
    min-height: 0;
  }
  .indicator-item {
    border-radius: 8px;
    background: #EFF2FC;
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;
    overflow: hidden;
  }
  // 指标名在上、环比在下，垂直堆叠。环比行固定预留一行高度，
  // 保证「有环比」与「无环比」卡片：指标名行、指标值行对齐，卡片高度一致。
  .indicator-main {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    min-width: 0;
  }
  .indicator-name {
    font-family: PingFangSC-Medium;
    font-weight: 600;
    font-size: 12px;
    color: #333333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    max-width: 100%;
  }
  .indicator-trend {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    flex-shrink: 0;
    white-space: nowrap;
    // 固定高度：无环比时同样占一行，保证指标值行对齐、卡片等高
    height: 16px;
    line-height: 16px;
    &.trend-up {
      color: #73B950;
    }
    &.trend-down {
      color: #F44F4F;
    }
    &.trend-flat {
      color: #F4B13D;
    }
  }
  .trend-value {
    font-weight: 500;
  }
  .trend-icon {
    font-size: 12px;
    font-weight: 900;
  }
  .indicator-value {
    display: flex;
    align-items: baseline;
    gap: 4px;
    min-width: 0;
  }
  .value-num {
    font-family: PingFangSC-Semibold;
    font-size: 24px;
    font-weight: 700;
    color: #333;
    line-height: 32px;
  }
  .value-unit {
    font-size: 12px;
    color: #333;
    font-weight: 400;
  }
}
@media screen and (max-width: 1440px) {
  .#{$class-prefix} {
    .value-num {
      font-size: 20px;
    }
  }
}
</style>
